const PaymentStatus = {
  status: {
    PROCESSING: "Processing",
    SUCCESS: "Success",
    CANCEL: "Cancel",
  },
};

export { PaymentStatus };
